import React, { useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import MoodTracker from './MoodTracker';
import ThoughtJournal from './ThoughtJournal';
import GratitudeLog from './GratitudeLog';
import EmotionWheel from './EmotionWheel';
import DailyReminder from './DailyReminder';
import InsightsDashboard from './InsightsDashboard';
import './SelfAwareness.css';
import './Components.css';

function SelfAwarness() {
  const [mood, setMood] = useState('');
  const [thoughtEntry, setThoughtEntry] = useState('');
  const [gratitudeItems, setGratitudeItems] = useState([]);
  const [emotion, setEmotion] = useState('');

  const summaryRef = useRef();

  const handleSaveSummaryImage = () => {
    html2canvas(summaryRef.current, {
      backgroundColor: '#ffffff',
      scale: 2,
    }).then((canvas) => {
      const link = document.createElement('a');
      link.download = 'self-awareness-summary.jpg';
      link.href = canvas.toDataURL('image/jpeg', 1.0);
      link.click();
    });
  };

  return (
    <div className="app-container">
      <h1>🧠 Self-Awareness Journal</h1>

      <div className="self-awareness-card">
        <DailyReminder />
        <MoodTracker mood={mood} setMood={setMood} />
        <ThoughtJournal thoughtEntry={thoughtEntry} setThoughtEntry={setThoughtEntry} />
        <GratitudeLog gratitudeItems={gratitudeItems} setGratitudeItems={setGratitudeItems} />
        <EmotionWheel emotion={emotion} setEmotion={setEmotion} />
        <InsightsDashboard />
      </div>

      {/* 📸 Save Summary Button */}
      <div className="highlight-button-container">
        <button className="highlight-button" onClick={handleSaveSummaryImage}>
          📸 Save Summary as Image
        </button>
      </div>

      {/* 📋 Always-Visible Summary Card */}
      <div ref={summaryRef} className="summary-card">
        <h2>📋 Self-Awareness Summary</h2>
        <p><strong>Mood:</strong> {mood || 'Not selected'}</p>
        <p><strong>Thoughts:</strong> {thoughtEntry || 'No entry yet'}</p>
        <p><strong>Gratitude:</strong></p>
        <ul>
          {gratitudeItems.length > 0 ? (
            gratitudeItems.map((item, index) => <li key={index}>🌟 {item}</li>)
          ) : (
            <li>No gratitude items added</li>
          )}
        </ul>
        <p><strong>Emotion Felt:</strong> {emotion || 'Not selected'}</p>
      </div>
    </div>
  );
}

export default SelfAwarness;
